import { gql } from "@apollo/client";

export const UPDATE_USER_INFO = gql`
  mutation updateUserSelectedMenu($tipMenu: String!) {
    updateUserSelectedMenu(tipMenu: $tipMenu)
  }
`;

export const UPDATE_CUM_COUNTER = gql`
  mutation Mutation($counter: Int) {
    updateCumCounter(counter: $counter)
  }
`;
